import { Archive } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import { Button } from '@/components/ui/button.tsx';
import { usePlantsViewFilterStore } from '@/services/store/use-plants-view-filter-store.ts';

export const PlantsArchiveToggle = () => {
  const { showArchived, setShowArchived } = usePlantsViewFilterStore(
    useShallow((state) => ({
      showArchived: state.showArchived,
      setShowArchived: state.setShowArchived,
    }))
  );

  return (
    <Button
      title={showArchived ? 'Hide Archive' : 'Show Archive'}
      variant="ghost"
      size="sm"
      onClick={() => setShowArchived(!showArchived)}
      className={`min-h-9 gap-2 rounded-md border border-gray-200 bg-white px-3 ${
        showArchived ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      <Archive className="h-4 w-4" />
    </Button>
  );
};
